import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GrupoProdutos } from '../interfaces/grupo-produtos';
import { PageResult } from '../interfaces/page-result';
import { environment } from '../../../environments/environment';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProdutoGrupoService {


  readonly path = '/produto/grupo';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  create(): Observable<GrupoProdutos> {
    return this.http.post<GrupoProdutos>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  getProdutoGrupoPage(page?: number, size?: number): Observable<PageResult<GrupoProdutos>> {
    return this.http.get<PageResult<GrupoProdutos>>(
      `${this.jwtAuthService.apiUrl + this.path}/page/get/v2?page=${page}&size=${size}`);
  }

  getProdutoGrupoPageSearch(page?: number, size?: number,
    search?: string, order?: string, direction?: string, desativado?: boolean): Observable<PageResult<GrupoProdutos>> {
    return this.http.get<PageResult<GrupoProdutos>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/v2?page=${page}&size=${size}&search=${search}`
      + `&order=${order}&direction=${direction}&desativado=${desativado}`);
  }

  getProdutoGrupoList(): Observable<GrupoProdutos[]> {
    return this.http.get<GrupoProdutos[]>(
      `${this.jwtAuthService.apiUrl + this.path}/lista/get`);
  }

  saveOrUpdate(grupo: GrupoProdutos): Observable<GrupoProdutos> {
    return this.http.put<GrupoProdutos>(`${this.jwtAuthService.apiUrl + this.path}`, grupo);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

}
